
const Pay = () => {
  return (
    <div className="content">
      <h1>Default payment link</h1>
    </div>
  );
};
export default Pay;
